import React, {Component} from 'react';
import PropTypes from 'prop-types';


import Grid from '@mui/material/Grid';
import ShoppingCart from '@mui/icons-material/ShoppingCart';
import MenuBox from './MenuBox';
import {colors} from '../../base';

const s:any = {
  active: {
    color: 'primary.main',
    fontWeight: 'typography.fontWeightMedium',
  },
  nested: {
    paddingLeft: 'spacing(4)',
  },
  itemicon: {
    minWidth: 24,
    marginRight: 8,
  },
  child: {
    margin: 50,
  }
};

class KanbanMenuChild extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  // static propTypes: { classes: PropTypes.Validator<object>; onClick: PropTypes.Requireable<(...args: any[]) => any>; openImmediately: PropTypes.Requireable<boolean>; title: PropTypes.Validator<string>; };
  // constructor(props:any) {
  //   super(props);
  // }
  componentDidMount() {
    // So we only run this logic once.
    if (!this.props.openImmediately) {
      return;
    }

    // Center the selected item in the list container.
    const activeElement = document.querySelector(`.${this.props.classes.active}`);
    if (activeElement && activeElement.scrollIntoView) {
      activeElement.scrollIntoView({});
    }
  }

  render() {
    const {
      children,
      classes,
      index,
      itemid,
      icon,
      action,
      onClick,
      openImmediately,
      title,
      ...other
    } = this.props;

    return (
      <Grid size={{xs:2}} sx={{...s.child}}>
        <MenuBox 
          Icon={ShoppingCart}
          icon={icon}
          color={colors[index]}
          title={title}
          value={""}
          onClick={onClick}
        />
      </Grid>
    );
    
  }
}

KanbanMenuChild.propTypes = {
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  openImmediately: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

KanbanMenuChild.defaultProps = {
  openImmediately: false,
};

export default KanbanMenuChild;
